<template>
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">

      <el-tab-pane label="技师提现" name="waitercash">
        <waitercash v-if="activeName=='waitercash'"></waitercash>
      </el-tab-pane>
      <el-tab-pane label="用户提现" name="usercash">
        <usercash v-if="activeName=='usercash'"></usercash>
      </el-tab-pane>
      <el-tab-pane label="商户提现" name="suppliercash">
        <suppliercash v-if="activeName=='suppliercash'"></suppliercash>
      </el-tab-pane>
      <el-tab-pane label="渠道提现" name="cashrewords">
        <cashrewords v-if="activeName=='cashrewords'"></cashrewords>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import bus from "@/utils/eventBus.js";
import cashrewords from "./cashrewords/index";
import waitercash from "./waitercash/cash";
import suppliercash from "./suppliercash/cash";
import usercash from "./usercash/cash";

// import Report from "./report/index";
export default {
  components: {
    cashrewords,
    waitercash,
    usercash,
    suppliercash
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*当前选中*/
      activeName: "waitercash"
    };
  },
  methods: {}
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/cash/cashmoney/index.vue